import { CSSProperties } from "react";

/**
 * Sets the document overflow value, so it can be updated as needed
 * used mostly when dialog backdrop are open to blocked scrolling
 * outside the dialog content
 * Note:
 * Once :has() functionally is supported on more browsers
 * this can be deprecated and use the CSS approach
 * @param value The new overflow value for the Document element
 */

export function setDocumentOverflow(value: CSSProperties["overflow"]): void {
    window.document.body.style.overflowY= value ?? "";
}
